import styled from 'styled-components'
import { Select, Layout } from 'antd'
import { lighten } from 'polished'

import config from '~/config'
const {
  colors,
  headerHeight,
  controlWidth,
  chartWidth,
  chartHeight
} = config.ui

const HEADER_HEIGHT = `${headerHeight}px`
const CONTROL_WIDTH = `${controlWidth}px`
const CHART_WIDTH = `${chartWidth}px`
const CHART_HEIGHT = `${chartHeight}px`

// const COLORS ={
//   celestial: 'rgb(42, 139, 187)',
//   birdseye: 'rgb(56, 100, 152)',
//   airy: 'rgb(127, 200, 213)',
//   plainivory: 'rgb(255, 255, 247)',
//   darkgrey: '#404040'
// }

const AppLayout = styled(Layout)`
  background: none;
`

const Control = styled.h2`
  width: ${CONTROL_WIDTH};
  color: white;
  font-size: 14px;
  padding: 8px;
`

const ControlSelect = styled(Select)`
  width: 150px;
  padding: 0 8px;
`
// TODO: this is hacky, should be a way to do multi line checkboxes
// const ControlCheckbox = styled(Checkbox)`
//   display: block !important;
//   margin: 0 !important;
// `

const MainLayout = styled(Layout)`
  overflow: auto;
  min-width: 1280px;
  height: calc(100vh - ${HEADER_HEIGHT});
  background: none;
`

const MapLayout = styled.div`
  width: calc(100vw - (${CONTROL_WIDTH} + ${CHART_WIDTH}));
  min-width: 480px;
  height: calc(100vh - ${HEADER_HEIGHT});
  display: block;
  left: 200px;
  position: absolute;
  overflow: hidden;
`

const SearchLayout = styled.div`
  position: absolute;
  top: 50px;
  left: 18px;
  width: 500px;
  z-index: 1;
  background: rgba(255, 255, 255, 0.8);
  padding: 4px 24px 0;
  border-radius: 4px;
`

const ContentLayout = styled.div`
  width: 100%;
  min-height: 100%;
  display: block;
  ::before {
    content: '';
    background-color: ${({ mode }) => colors[mode] || 'black'};
    display: block;
    width: ${CONTROL_WIDTH};
    height: calc(100vh - ${HEADER_HEIGHT});
    left: 0;
    position: absolute;
    z-index: -1;
  }
`

const FooterLayout = styled(Layout.Footer)`
  background: ${colors.dark};
  color: white;
`

const ControlSection = styled.div`
  color: white;
  box-sizing: border-box;
  height: ${CHART_HEIGHT};
  width: ${CONTROL_WIDTH};
  display: block;
  float: left;
  margin-right: calc(100% - (${CONTROL_WIDTH} + ${CHART_WIDTH}));
  padding: 8px;
  overflow-y: auto;
  .ant-checkbox-group {
    display: block;
    color: white;
  }
  .ant-checkbox-wrapper {
    color: white;
  }
`

const ChartSection = styled.div`
  box-sizing: border-box;
  width: ${CHART_WIDTH};
  height: ${CHART_HEIGHT};
  display: block;
  float: left;
  background: "#ffffff";
  .chartTitle {
    color: black;
    font-size: small;
    text-align: center;
  }
`

const Section = styled.div`
  color: white;
  font-size: 16px;
  box-sizing: border-box;
  :hover > ${ChartSection} {
    background-color: ${lighten(0.05, colors.light)};
  }
  ${Control} {
    margin-bottom: 0;
  }

  .ant-form-item-label {
    color: white;
    label {
      color: white;
    }
  }
  .ant-radio-wrapper {
    color: white;
  }
`

const Pin = styled.div`
  width: 16px;
  height: 16px;
  border: 3px solid ${({ color }) => color || 'grey'};
  border-radius: 8px 8px 8px 0;
  transform: translateY(-11px) rotate(-45deg);
  ${({ main }) => main && `box-shadow: 0 0 0 5px ${colors.primary};`}
`

const ScaleColor = styled.div`
  background-color: ${({ color }) => color};
`
const ColorScales = styled.div`
  position: absolute;
  bottom: 30px;
  left: 10px;
  .range {
    background: white;
  }
  ${ScaleColor} {
    width: 25px;
    height: 25px;
  }
`

export {
  AppLayout,
  Control,
  ControlSelect,
  MainLayout,
  MapLayout,
  SearchLayout,
  ContentLayout,
  FooterLayout,
  Section,
  ControlSection,
  ChartSection,
  Pin,
  ColorScales,
  ScaleColor
}



// WEBPACK FOOTER //
// ./src/components/styles.js